export const fileList = {
  time: '更新：{time}'
}
